export default __webpack_public_path__ + "static/media/icon_log.386bbbca.svg";